// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let ProfilePhotoInput = require("../common/Components/ProfilePhotoInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let FragmentErrorBoundary = require("../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember_graphql = require("../../__generated__/UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember_graphql.bs.js");
let UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql = require("../../__generated__/UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql.bs.js");
let UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember_graphql = require("../../__generated__/UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember_graphql.bs.js");
let UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember_graphql = require("../../__generated__/UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember_graphql.bs.js");

let convertVariables = UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let MemberPhotoMutation_imageContentType_decode = UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql.Utils.imageContentType_decode;

let MemberPhotoMutation_imageContentType_fromString = UnifiedDisplayOnlyMemberPhotoFormMemberPhotoMutation_graphql.Utils.imageContentType_fromString;

let MemberPhotoMutation = {
  imageContentType_decode: MemberPhotoMutation_imageContentType_decode,
  imageContentType_fromString: MemberPhotoMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function useMemberPhoto() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedDisplayMemberPhoto;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

let convertFragment = UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function UnifiedDisplayOnlyMemberPhotoForm$CurrentPhoto(props) {
  let member = RescriptRelay_Fragment.useFragment(UnifiedDisplayOnlyMemberPhotoForm_currentPhoto_displayOnlyMember_graphql.node, convertFragment, props.member);
  let profilePicture = member.profilePicture;
  let src = profilePicture !== undefined ? profilePicture.url : AvatarSrcUrl.placeholder;
  let match = member.profilePicture;
  let alt = match !== undefined ? "Your current profile picture" : "Placeholder profile picture showing a person's silhouette";
  return JsxRuntime.jsx("img", {
    className: "w-24 h-24 rounded-full",
    alt: alt,
    src: src
  });
}

let CurrentPhoto = {
  Fragment: Fragment,
  make: UnifiedDisplayOnlyMemberPhotoForm$CurrentPhoto
};

let convertFragment$1 = UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function UnifiedDisplayOnlyMemberPhotoForm$ChangeProfilePhoto(props) {
  let member = RescriptRelay_Fragment.useFragment(UnifiedDisplayOnlyMemberPhotoForm_changeProfilePhoto_displayOnlyMember_graphql.node, convertFragment$1, props.member);
  let match = useMemberPhoto();
  let save = match[0];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(ProfilePhotoInput.make, {
        onSubmit: (param, param$1) => {
          let notifyOnSuccess = param$1.notifyOnSuccess;
          save({
            image: UnifiedProfileSave.fromPhoto(param.croppedPhoto),
            memberNodeId: member.nodeId,
            originalImage: UnifiedProfileSave.fromPhoto(param.originalPhoto)
          }, () => {
            notifyOnSuccess();
            window.location.reload();
          }, param$1.notifyOnError);
        },
        onPhotoSelected: () => {},
        buttonText: "Change photo"
      }),
      match[2]
    ],
    className: "space-y-3"
  });
}

let ChangeProfilePhoto = {
  Fragment: Fragment$1,
  make: UnifiedDisplayOnlyMemberPhotoForm$ChangeProfilePhoto
};

let convertFragment$2 = UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember_graphql.node, convertFragment$2, fRef);
}

let Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function UnifiedDisplayOnlyMemberPhotoForm$WithoutErrorBoundary(props) {
  let member = RescriptRelay_Fragment.useFragment(UnifiedDisplayOnlyMemberPhotoForm_displayOnlyMember_graphql.node, convertFragment$2, props.member);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(UnifiedDisplayOnlyMemberPhotoForm$CurrentPhoto, {
          member: member.fragmentRefs
        }),
        JsxRuntime.jsx(UnifiedDisplayOnlyMemberPhotoForm$ChangeProfilePhoto, {
          member: member.fragmentRefs
        })
      ],
      className: "mt-2 sm:mt-0 flex gap-6 items-center md:flex-col lg:flex-row"
    }),
    className: "sm:py-6 space-y-4"
  });
}

let WithoutErrorBoundary = {
  make: UnifiedDisplayOnlyMemberPhotoForm$WithoutErrorBoundary
};

function UnifiedDisplayOnlyMemberPhotoForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Profile photo",
    children: JsxRuntime.jsx(UnifiedDisplayOnlyMemberPhotoForm$WithoutErrorBoundary, {
      member: props.member
    })
  });
}

let make = UnifiedDisplayOnlyMemberPhotoForm;

exports.MemberPhotoMutation = MemberPhotoMutation;
exports.useMemberPhoto = useMemberPhoto;
exports.CurrentPhoto = CurrentPhoto;
exports.ChangeProfilePhoto = ChangeProfilePhoto;
exports.Fragment = Fragment$2;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* commitMutation Not a pure module */
